/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MainDataVersion,
    MainDataVersionFromJSON,
    MainDataVersionFromJSONTyped,
    MainDataVersionToJSON,
    TagCategory,
    TagCategoryFromJSON,
    TagCategoryFromJSONTyped,
    TagCategoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface MainDataResTagCategoryArray
 */
export interface MainDataResTagCategoryArray {
    /**
     * 
     * @type {MainDataVersion}
     * @memberof MainDataResTagCategoryArray
     */
    version: MainDataVersion;
    /**
     * 
     * @type {Array<TagCategory>}
     * @memberof MainDataResTagCategoryArray
     */
    data?: Array<TagCategory> | null;
    /**
     * 
     * @type {string}
     * @memberof MainDataResTagCategoryArray
     */
    error?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResTagCategoryArray
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResTagCategoryArray
     */
    total?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResTagCategoryArray
     */
    limit?: number | null;
}

export function MainDataResTagCategoryArrayFromJSON(json: any): MainDataResTagCategoryArray {
    return MainDataResTagCategoryArrayFromJSONTyped(json, false);
}

export function MainDataResTagCategoryArrayFromJSONTyped(json: any, ignoreDiscriminator: boolean): MainDataResTagCategoryArray {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': MainDataVersionFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(TagCategoryFromJSON)),
        'error': !exists(json, 'error') ? undefined : json['error'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function MainDataResTagCategoryArrayToJSON(value?: MainDataResTagCategoryArray | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': MainDataVersionToJSON(value.version),
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(TagCategoryToJSON)),
        'error': value.error,
        'offset': value.offset,
        'total': value.total,
        'limit': value.limit,
    };
}


